import { Card, CardContent, CardHeader, Collapse, makeStyles } from '@material-ui/core'
import { ExpandLessOutlined, ExpandMoreOutlined } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'

import { ListWithAddButton } from '../Common/ListWithAddButton'

const useStyles = makeStyles((theme) => ({
	header: {
		width: '100%',
		paddingRight: 24,
		paddingLeft: 0,
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		cursor: 'pointer'
	}
}))

const PermitedMealAdjustments = (props) => {
	const classes = useStyles()
	let { selectedFacility, setCurrent } = props
	const [isExpanded, setIsExpanded] = useState(false)

	const updateFacility = (key, val) => {
		setCurrent({ ...selectedFacility, [key]: val })
	}

	return (
		<Card style={{ maxWidth: '1245px' }}>
			<div className={classes.header} onClick={() => setIsExpanded(!isExpanded)}>
				<CardHeader title="Permitted Meal Adjustments" />
				<div style={{ cursor: 'pointer', display: 'flex' }}>
					{isExpanded ? (
						<ExpandLessOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
					) : (
						<ExpandMoreOutlined style={{ fill: '#777679', cursor: 'pointer' }} />
					)}
				</div>
			</div>
			<Collapse
				in={isExpanded}
				timeout="auto"
				unmountOnExit
				style={{ background: 'transparent', cursor: 'default' }}>
				<CardContent>
					<ListWithAddButton
						list={selectedFacility?.permitted_meal_adjustments}
						label="Permitted Meal Adjustment"
						onChange={(list) => {
							updateFacility('permitted_meal_adjustments', list)
						}}
						onDelete={(list) => {
							updateFacility('permitted_meal_adjustments', list)
						}}
						onAdd={(list) => {
							updateFacility('permitted_meal_adjustments', list)
						}}
						maxCharacters={100}
						addButtonLabel="Adjustment"
					/>
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default PermitedMealAdjustments
